import { createRoutine } from 'redux-saga-routines';

export const checkUser = createRoutine('CHECK_USER');
export const clearExtractedUsers = createRoutine('CLEAR_EXTRACTED_USERS');
export const fetchUserAvatar = createRoutine('FETCH_USER_AVATAR');
export const fetchUsersBatchFromGroup = createRoutine('FETCH_USERS_BATCH_FROM_GROUP');
export const fetchUsersFromGroup = createRoutine('FETCH_USER_FROM_GROUP');
export const loadingUsers = createRoutine('LOADING_USERS');
export const makeDistinctUsersFromCombined = createRoutine('MAKE_DISTINCT_USERS_FROM_COMBINED');
export const stopSyncingUsers = createRoutine('STOP_SYNCING_USERS');
export const stopSyncingUserInfo = createRoutine('STOP_SYNCING_USER_INFO');

export const syncUsers = createRoutine('SYNC_USERS');
export const syncUserInfo = createRoutine('SYNC_USER_INFO');

export const updateActiveUsers = createRoutine('UPDATE_ACTIVE_USERS');
export const updateUserInfo = createRoutine('UPDATE_USER_INFO');
